/**
 * Google Tag Manager transport. GA4 conversions — and any Google Ads
 * conversion action importing them — are driven entirely by the `dataLayer`;
 * PostHog's ingestion is invisible to Google. Every event that matters to
 * marketing therefore has to land here too.
 */

export const GTM_ID = import.meta.env.VITE_GTM_ID as string | undefined;

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/**
 * Pushes an event onto the `dataLayer` for GTM to trigger a tag off.
 *
 * The GTM snippet in `src/routes/__root.tsx` creates `dataLayer` synchronously
 * even though it defers loading `gtm.js` until the window `load` event, so
 * pushes made before the container is ready queue up rather than being lost.
 *
 * For GA4 to see these, add a Custom Event trigger per event name (or one
 * regex trigger) feeding a GA4 Event tag. Outbound-link events must set
 * `transport_type: beacon` on that tag, or the hit is cancelled on unload.
 */
export function pushToDataLayer(event: string, props?: Record<string, unknown>): void {
  if (!GTM_ID || typeof window === "undefined") return;
  window.dataLayer?.push({ event, ...props });
}
